import {defineMessages} from 'react-intl';

const messages = defineMessages({
  infoBanner: {
    id: 'infoBanner',
    defaultMessage:
      "We use cookies to improve user experience and analyze website traffic. By accepting you agree to our website's cookie use as described in our {cookiePolicyLink}."
  },
  managePreferences: {
    id: 'managePreferences',
    defaultMessage: 'Manage preferences'
  },
  accept: {
    id: 'accept',
    defaultMessage: 'Accept'
  },
  cookiePolicy: {
    id: 'cookiePolicy',
    defaultMessage: 'Cookie policy'
  },
  couldntSavePreferences: {
    id: 'couldntSavePreferences',
    defaultMessage: "Couldn't save preferences"
  }
});

export default messages;
